export enum FileShareResultType {
  SHARED = 'shared',
  CANCELLED = 'cancelled',
  NEEDS_GESTURE = 'needs-gesture',
  UNSUPPORTED = 'unsupported',
}
